import { useNow } from "@/hooks/use-now"
import { formatClock, formatTimestamp } from "@/lib/format"

export function DeadlineCountdown({
  deadline,
  kind = "run",
}: {
  deadline: number | null
  kind?: "run" | "report"
}) {
  const now = useNow(1000)
  if (deadline === null) return <span>No deadline</span>
  const left = deadline - now
  return (
    <span title={formatTimestamp(deadline)}>
      {left <= 0 ? (
        kind === "report" ? (
          "Report deadline passed"
        ) : (
          "Closed"
        )
      ) : (
        <>
          {kind === "report" ? "Due in " : "Closes in "}
          <span className="font-mono font-bold tabular-nums">{formatClock(left)}</span>
        </>
      )}
    </span>
  )
}
